import { Injectable } from '@angular/core';
import { WarehouseConfiguration } from 'src/app/constants/constants/warehouse-api-config';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoleManagementService {
  BASE_DOMAIN = environment.BASE_DOMAIN
  
  constructor(private api : ApiService,private API_URL: WarehouseConfiguration) { }

  getMethod(){
    const url = `${environment.New_BASE_DOMAIN}${this.API_URL.CONFIG_URL.GET_CLIENTS_BY_ID}`;
    return this.api.get(url);
  }
  

  postMethod(user:any) {
    return this.api.post(this.BASE_DOMAIN+`${this.API_URL.CONFIG_URL.SIGNUP}`, user);
  }

  getUserList(filter:any,pageNumber:number,pageSize:number) {
    const url = `${environment.New_BASE_DOMAIN}${this.API_URL.CONFIG_URL.USER_LIST}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    return this.api.post(url,filter);
  }
  createUser(form:any) {
    const url = `${environment.New_BASE_DOMAIN}${this.API_URL.CONFIG_URL.CREATE_USER}`;
    return this.api.post(url,form);
  }

  updateUser(form:any) {
    const url = `${environment.New_BASE_DOMAIN}${this.API_URL.CONFIG_URL.UPDATE_USER}`;
    return this.api.put(url,form);
  }

  checkUser(user:any) {
    const url = `${environment.New_BASE_DOMAIN}${this.API_URL.CONFIG_URL.CHECK_USER}${user}`;
    return this.api.get(url);
  }
  getRolelist(data:any,pageNumber:any,pageSize:any){
    const url = `${environment.New_BASE_DOMAIN}auth-service/role/getUserRole?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    return this.api.post(url,data);
  }
  getRoleDatabyId(id:any){
    const url = `${environment.New_BASE_DOMAIN}ftl-service/role/getRoleById?platform=ems&roleId=${id}`;
    return this.api.get(url);
  }
  updateRole(data:any){
    const url = `${environment.New_BASE_DOMAIN}auth-service/role/updateSubmoduleDetails?platform=ems`;
    return this.api.post(url,data);
  }
  createRole(data:any){
    const url = `${environment.New_BASE_DOMAIN}auth-service/role/createRoleMapping`;
    return this.api.post(url,data);
  }
  getAllModulesSubmodules(){
    const url = `${environment.New_BASE_DOMAIN}auth-service/role/getModules?platform=ems`
    return this.api.get(url);
  }
  getModuleSubmodule(ids:any){
    const url = `${environment.New_BASE_DOMAIN}auth-service/role/getModulesByRoleId?roleIds=${ids}&platform=ems`;
    return this.api.get(url);
  }
  getAllRoleList(){
    const url = `${environment.New_BASE_DOMAIN}auth-service/role/getRoleMappingList?platform=ems`;
    return this.api.get(url);
  }
}
